var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-dropdown",on:{"mouseenter":function($event){return _vm.$emit('openning', _vm.SET_LOADING)}}},[_vm._t("title"),(!_vm.hiddenDropdown)?_c('div',{staticClass:"c-dropdown__content",class:{
      [`c-dropdown__content--${_vm.size}`]: _vm.size,
      'c-dropdown__content--icon-title-right': _vm.iconTitleRight,
      'c-dropdown__content--right': _vm.align === 'right',
      'c-dropdown__content--left': _vm.align === 'left',
      'c-dropdown__content--radius-bottom': _vm.radiusBottom,
    }},[(_vm.isLoading)?_c('loading'):_vm._t("content")],2):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }